import React, { createContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop, Box, CircularProgress } from '@material-ui/core';

export const LoadingContext = createContext();

const Loading = props => {

    const [isReady, setIsReady] = useState(false);
    const { children } = props;
    const classes = useStyles();
   
    return (
        <LoadingContext.Provider value={{ isReady, setIsReady }}>
            {/* <Backdrop className={classes.backdrop} open={!isReady}>
                <CircularProgress />
            </Backdrop> */}
            {
                !isReady && (
                    <div className={classes.loader}>
                        <CircularProgress />
                    </div>
                )
            }
            { children }
        </LoadingContext.Provider>
    )
}

const useStyles = makeStyles((theme) => ({
    /*backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }*/
    loader: {
        width: '100%', 
        height: '100%', 
        zIndex: 9999999999999999, 
        backgroundColor: '#ffffff', 
        position: 'fixed', 
        top: 0, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center' 
    }
}));

export default Loading;